/* eslint-disable max-lines-per-function */
import React, { JSX, useEffect, useState } from "react";
import "./TimerStyles.css";
import { calculateDateTime } from "./util";
import ExpiredTimer from "./ExpiredTimer";
import {PRIMARYCOLORS, COLORWHITE} from "../../../utils/constants";
import { NativeColorPicker } from "./Timer.types";
export interface TimerSchema {
  startTime: string;
  endTime: string;
  colorChangeTime?: string;
  expiryLabel: string;
  timerColor?: string;
  backgroundColor: string;
  timerAlignment: string;
  dayLabel: string;
  hourLabel: string;
  minuteLabel: string;
  secondLabel: string;
  mainHeading: string;
  expiryLabelColor: NativeColorPicker;
  enableCounter: boolean;
  isDarkMode?: boolean;
}
interface Timer {
  content: TimerSchema;
}
export interface timeleft {
  days: string;
  hours: string;
  mins: string;
  sec: string;
}
const Timer = ({ content }: Timer): JSX.Element => {
  const expiry = calculateDateTime(
    new Date(content?.endTime?.replace(/-/g, "/"))
  );
  const start = calculateDateTime(
    new Date(content?.startTime?.replace(/-/g, "/"))
  );
  const changeColor =
    content?.colorChangeTime &&
    calculateDateTime(new Date(content?.colorChangeTime?.replace(/-/g, "/")));
  const [startTimer, setStartTimer] = useState(false);
  const [timerContentColor, setTimerContentColor] = useState(
    content?.timerColor ?? ""
  );
  const [colorChanged, setColorChanged] = useState(false);
  const calculateTime = (): timeleft | null => {
    const today = new Date();
    if (changeColor && !colorChanged)
      if (today.getTime() > changeColor.getTime()) {
        setTimerContentColor(PRIMARYCOLORS);
        setColorChanged(true);
      }
    if (today.getTime() >= start.getTime() && !startTimer) {
      setStartTimer(true);
    }
    const difference = expiry.getTime() - today.getTime();
    if (difference > 0 && startTimer) {
      const days = ("0" + Math.floor(difference / (1000 * 60 * 60 * 24))).slice(
        -2
      ); // adding leading zeroes for single digit
      const hours = (
        "0" + Math.floor((difference / (1000 * 60 * 60)) % 24)
      ).slice(-2);
      const mins = ("0" + Math.floor((difference / 1000 / 60) % 60)).slice(-2);
      const sec = ("0" + Math.floor((difference / 1000) % 60)).slice(-2);
      return { days, hours, mins, sec };
    }
    return null;
  };
  const expiredTimer = {
    timerColor: timerContentColor,
    backgroundColor: content?.backgroundColor,
    expiryLabel: content.expiryLabel,
    timerAlignment: content.timerAlignment,
    dayLabel: content.dayLabel,
    hourLabel: content.hourLabel,
    minuteLabel: content.minuteLabel,
    secondLabel: content.secondLabel,
    expiryLabelColor: content.expiryLabelColor,
  };
  const [timeLeft, setTimeLeft] = useState(calculateTime());
  useEffect(() => {
    setTimeLeft(calculateTime());
    const timer = setInterval(() => {
      setTimeLeft(calculateTime());
    }, 1000);
    return () => {
      clearInterval(timer);
    };
  }, []);
  const timeLeftArray = [
    //adding hours, mins and seconds to array so that this array can be mapped for displaying values
    { label: content?.hourLabel ?? "", value: timeLeft?.hours },
    { label: content?.minuteLabel ?? "", value: timeLeft?.mins },
    { label: content?.secondLabel ?? "", value: timeLeft?.sec },
  ];
  return (
    <div
      className={"timer-wrap"} style={{textAlign:'center'}}>
      {startTimer && (
        <div className={"timer-container"}>
          {timeLeft ? (
            <div
              className={"timer-section"}
              style={{
                color: content?.isDarkMode ? COLORWHITE : timerContentColor,
                backgroundColor: content?.backgroundColor ?? "transparent",
              }}
            >
              <div className={` ${"timer-element"} ${"transparent-element"}`}>
                <div className={"timer-value"}> {timeLeft?.days}</div>
                <div className={"timer-label"}>{content.dayLabel}</div>
              </div>
              {timeLeftArray.map((element: any, index: number) => (
                <React.Fragment key={index}>
                  <div className={"colon"}>:</div>
                  <div className={"timer-element"}>
                    <div className={"timer-value"}> {element.value}</div>
                    <div className={"timer-label"}>{element.label}</div>
                  </div>
                </React.Fragment>
              ))}
            </div>
          ) : (
            <ExpiredTimer content={expiredTimer} />
          )}
        </div>
      )}
    </div>
  );
};

export default Timer;
